<template>
  <div class="container my-2">
    <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="secondary"
    >
      {{message}}
    </b-alert>
          <div class="d-flex text-center">
              <img src="@/assets/Icon/add doctor schedule.svg" width="50"/>
              <h3 class="textmargin" style="margin-top: 10px;">ADD DOCTOR & NURSE SCHEDULE</h3>
          </div>
            <div class="d-block">
              <b-card bg-variant="light" class="card text-center mx-2 my-2 text-purple">
              <form @submit.prevent="onSubmit">
                <b-row class="my-3">
            <b-col cols="2">
              <label class="mt-2" aria-controls="fieldset-6">Nama Dokter</label>
            </b-col>
              <b-col cols="10">
                <b-form-select v-model="doctor_id" class="hdrop w100">
                    <option :value="null" disabled>-- Pilih --</option>
                    <option v-for="nurse in dokter" :key="nurse.id" :value="nurse.id">
                      {{ nurse.name }}
                    </option>
                  </b-form-select>
              </b-col>
          </b-row>

            <b-row class="my-3">
            <b-col cols="2">
              <label class="mt-2" aria-controls="fieldset-6">Nama Perawat</label>
            </b-col>
              <b-col cols="10">
                <b-form-select v-model="nurse_id" class="hdrop w100">
                    <option :value="null" disabled>-- Pilih --</option>
                    <option v-for="nurse in perawat" :key="nurse.id" :value="nurse.id">
                      {{ nurse.name }}
                    </option>
                  </b-form-select>
              </b-col>
          </b-row>

            <b-row class="my-3">
              <b-col cols="2">
                <label class="mt-2" aria-controls="fieldset-1">Jenis Perawatan</label>
              </b-col>
                <b-col cols="10">
                    <b-form-group id="fieldset-1">
                        <b-form-input id="input-1" disabled v-model="jenis_perawatan" trim class="hdrop"></b-form-input>
                    </b-form-group>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col cols="2">
                <label class="mt-2" aria-controls="fieldset-1">Pilih Hari</label>
              </b-col>
                <b-col cols="10">
                 <b-form-datepicker id="example-datepicker" v-model="date" class="mb-2 hdrop"></b-form-datepicker>
                </b-col>
            </b-row>

                  <b-row class="my-3">
            <b-col cols="2">
              <label class="mt-2" aria-controls="fieldset-6">Sesi</label>
            </b-col>
              <b-col cols="10">
                <b-form-select v-model="session_id" class="hdrop w100">
                    <option :value="null" disabled>-- Pilih --</option>
                    <option v-for="nurse in sesi" :key="nurse.id" :value="nurse.id">
                      {{ nurse.name }}
                    </option>
                  </b-form-select>
              </b-col>
          </b-row>
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button class="btn btn-primary me-md-2" type="submit">SUBMIT</button>
                <button class="btn btn-primary" type="reset">RESET</button>
            </div>
              </form>
          </b-card>
          </div>  
      </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
      name: 'addnurseSchedule',
      computed: {
      },
      data() {
        return {
          jenis_perawatan: 'Rawat Jalan',
          date: '',
          session_id: null,
          doctor_id: null,
          nurse_id: null,
          sesi: [
          ],
          dokter: [
          ],
          perawat: [
          ],        
          message: '',
          showTop: false
     }
      },
      methods: {
        async onSubmit(){
        const data = {
          doctor_id: this.doctor_id,
          date: this.date,
          nurse_id: this.nurse_id,
          session_id: this.session_id,
        }
        console.log(data)
        const token = this.$localStorage.get('token')
        console.log(token)
        await axios.post('schedule/post', data, {
        headers: { "Authorization" : 'Bearer ' + token
        }
      })
      .then(response => {
        console.log(response)
        const messageTrue = "Data Telah Tersimpan"
        this.$localStorage.set('messageSchedule', messageTrue)
        this.$router.push('scheduleList')
      })
      .catch(error => {
        console.log(error.response.data.error)
        const errorinput = error.response.data.error
        if(error){
              this.message = errorinput
              this.showTop = true,
              // this.toggleLength = true
              setTimeout(() => {
            this.showTop = false;
            // this.toggleLength = false

                  }, 2000);
        }
      })
      }
      },
      async mounted() {
    try {
    const response = await axios.get('antrian');
    // const antrian = response.data.medic_record.length
    const dokter = response.data.doctor_table
    const perawat = response.data.nurse_table
    // const pasien = response.data.patient
    const session = response.data.session
    // this.kode_pasien = pasien 
    this.perawat = perawat
    this.dokter = dokter
    // this.queue = antrian + 1
    this.sesi = session
  } catch(e) {
    console.log(e);

        }
      }
  }
  </script>
  
  
  <style scoped>
  .unguprimary {
      background-color: #50266A;
  }
  .ungusecondary {
      background-color: #794B93;
  }
  .hdrop {
    height: 38px;
  margin-top: 5px;
  margin-bottom: 5px;
 border-radius: 5px; 
 border: 1px solid #1b1515;
 background: #F3F3F3;
  }
  .btn{
    color:rgb(255, 255, 255);
    background: #794B93;
}
  .w100{
  width: 100%;
}
  /* .selectWrapper{
    border-radius:5px;
    overflow:hidden;
    background:#ffffff;
    border:1px solid #1b1515;
  } */
  </style>